
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open/login-questions",
      function () {
        return require("private-next-pages/open/login-questions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open/login-questions"])
      });
    }
  